<script setup>
import { computed } from "vue";

// rows: [{ label, value, color?, gradient? }]
const props = defineProps({
  rows: { type: Array, required: true },
});

const max = computed(() => Math.max(...props.rows.map((r) => r.value)) || 1);
const fillFor = (r) =>
  r.gradient ? "linear-gradient(90deg, var(--an-accent-2), #5b3fd6)" : r.color || "var(--an-accent)";
</script>

<template>
  <div class="an-hbars">
    <div v-for="(r, i) in rows" :key="i">
      <div class="an-hbar__top"><span>{{ r.label }}</span><b>{{ r.value }}</b></div>
      <div class="an-hbar__track">
        <div
          class="an-hbar__fill"
          :style="{ background: fillFor(r), width: ((r.value / max) * 100).toFixed(1) + '%', animationDelay: i * 0.08 + 's' }"
        ></div>
      </div>
    </div>
  </div>
</template>
